import React from 'react';
import { Outlet } from 'react-router-dom';
import PortalLockGuard from '../components/PortalLockGuard';
import PortalPendingStartGate from '../components/PortalPendingStartGate';

const PortalLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 w-full overflow-x-hidden">
      <main className="p-6">
        <PortalPendingStartGate>
          <PortalLockGuard>
            <Outlet />
          </PortalLockGuard>
        </PortalPendingStartGate>
      </main>
    </div>
  );
};

export default PortalLayout; 